import * as Yup from "yup";

import { AcceptRejectFoldInternalState } from "./AcceptRejectFold";
import { regexList } from "../../../Constants";

export const acceptRejectFoldConstants = {
  labels: {
    other: "Other",
    acceptMessage: "eligibility Amount Accepted",
    rejectMessage: "rejection status updated",
    rejectModalHeader: "Reject information",
    rejectReasonTitle: "Sorry to hear, please provide your reason for rejection"
  },
  placeholders: {
    manualReason: "Reason"
  },
  buttons: {
    accept: "Accept",
    reject: "Reject",
    submit: "Submit",
    cancel: "Cancel"
  }
};

const errorMessages = {
  required: "Enter a reason",
  invalidFormat: "Invalid Format"
};

export const acceptRejectFoldValidationSchema = Yup.object().shape<
  AcceptRejectFoldInternalState
>({
  reason: Yup.string().required(errorMessages.required),
  manualReason: Yup.string()
    .nullable()
    .when("reason", {
      is: acceptRejectFoldConstants.labels.other,
      then: Yup.string()
        .required(errorMessages.required)
        .nullable()
        .matches(regexList.minimum1Character, errorMessages.invalidFormat)
    }),
  isRejectReasonManual: Yup.boolean().nullable()
});
